import { tokenStorage } from "../../utils/tokenStorage";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isAuthenticated: Boolean(tokenStorage.get()),
  isLoggingIn: false,
  loginError: null,

  profile: null,
  isLoadingProfile: false,
  profileError: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, isLoggingIn: true, loginError: null };
    case LOGIN_SUCCESS:
      return { ...state, isLoggingIn: false, isAuthenticated: true };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggingIn: false,
        isAuthenticated: false,
        loginError: action.payload,
      };

    case LOGOUT:
      return { ...initialState, isAuthenticated: false };

    case FETCH_PROFILE_REQUEST:
      return { ...state, isLoadingProfile: true, profileError: null };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        isLoadingProfile: false,
        profile: action.payload,
      };
    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        isLoadingProfile: false,
        profileError: action.payload,
      };

    default:
      return state;
  }
}
